import { createTheme } from "@mui/material/styles"
import { ReactComponent as DownIcon } from "../Icons/down_arrow.svg"

export const getMuiTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      background: {
        default: mode === "dark" ? "#141922" : "#ffffff",
        paper: mode === "dark" ? "#1e2532" : "#ffffff",
      },
    },
    components: {
      MuiSelect: {
        defaultProps: {
          IconComponent: DownIcon,
        },
        styleOverrides: {
          icon: {
            color: "inherit",
            right: "12px",
          },
        },
      },
    },
  })
